export default __webpack_public_path__ + "static/media/edit_icon_role.3cfd8802.svg";